import { jsx as _jsx } from "react/jsx-runtime";
var Phone = function Phone(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 14 14",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      fill: !ignoreColor ? color : undefined,
      clipRule: "evenodd",
      d: "M3.40016 1.66667C2.44416 1.66667 1.66683 2.444 1.66683 3.4C1.66683 8.32533 5.67416 12.3333 10.6002 12.3333C11.5555 12.3333 12.3335 11.556 12.3335 10.6C12.3335 10.526 12.3288 10.4533 12.3195 10.3813L9.2395 9.67467C9.17816 9.792 9.11083 9.91933 9.0495 10.038C8.7455 10.618 8.5255 11.0393 7.96416 10.8133C5.76016 10.04 3.96083 8.24 3.1775 6.00933C2.9395 5.486 3.39283 5.24867 3.9675 4.94867C4.08416 4.88733 4.21016 4.82133 4.3255 4.76133L3.61883 1.68067C3.54483 1.67133 3.47283 1.66667 3.40016 1.66667ZM10.6002 13.6667C4.93883 13.6667 0.333496 9.06133 0.333496 3.4C0.333496 1.70867 1.70883 0.333332 3.40016 0.333332C3.5735 0.333332 3.74483 0.347999 3.91083 0.376665C4.07283 0.402665 4.2355 0.443999 4.39416 0.498665C4.61083 0.573999 4.77416 0.755999 4.8255 0.979999L5.73816 4.956C5.78883 5.17467 5.7255 5.404 5.5695 5.56667C5.47883 5.66133 5.47683 5.66333 4.65016 6.096C5.3195 7.54533 6.48283 8.70467 7.90283 9.35133C8.33616 8.524 8.33883 8.52133 8.4335 8.43067C8.59616 8.27467 8.82683 8.214 9.04416 8.262L13.0208 9.17467C13.2442 9.226 13.4262 9.38867 13.5008 9.60533C13.5555 9.76267 13.5968 9.92533 13.6242 10.0927C13.6522 10.2573 13.6668 10.428 13.6668 10.6C13.6668 12.2913 12.2908 13.6667 10.6002 13.6667Z"
    })
  });
};
export default Phone;